module.exports = __webpack_public_path__ + "static/media/desk contact.ec11f3ab.svg";